import { ViewModel,View, ObservableArray } from "binder"
import  { SearchableSelectorBaseView } from "./searchableSelectorBase-view"

export type ElementType = {
    set title(v: string);
    get title(): string;
    set id(v: string);
    get id(): string;
};


export abstract class SearchableSelectorBaseViewModel<T extends ElementType> extends ViewModel{
    
    protected useReturnKey : boolean;
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.useReturnKey = false;
        this.items = ObservableArray.create<itemContainer<T>>();
        this.isShowingPopup = false;
    }

    GetDefaultView(): View <ViewModel> {
        return new SearchableSelectorBaseView();
    }
    public getTypeId(): string {
        return "VM-1EFF89D3-47BC-4D49-BE3E-706356BEC01E"
    }

    public set items(v: ObservableArray<itemContainer<T>>) { this._items = v; } public get items(): ObservableArray<itemContainer<T>> { return this._items;} private _items: ObservableArray<itemContainer<T>>;
    public set selectedItem(v: T) { 
        this._selectedItem = v;
        this.onSelectionChanged(v);
        this.isShowingPopup = false;
    } public get selectedItem(): T { return this._selectedItem;} private _selectedItem: T;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set searchedText(v: string) { 
        this._searchedText = v;
        this.scheduleSearch();
    } public get searchedText(): string { return this._searchedText;} private _searchedText: string;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    
    private timer:any;
    scheduleSearch(){
        if(this.useReturnKey==true)
            return;
        if(this.timer!=null)
            clearTimeout(this.timer);
        setTimeout(()=>this.refresh(),1000);
    }

    async refresh(){
        this.lastRunAction =()=> this.refresh();
        try {
            this.isLoading = true;
            let result =await this.loadData(this.searchedText);
            this.items.update(...result.map(x=>{
                let r = new itemContainer<T>(this);
                r.content = x;
                return r;
            }));
            this.isShowingPopup = true;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    public async selectById(id:string){
        this.lastRunAction = ()=>this.selectById(id);
        if(id==null){
            this.selectedItem = null;
        }else{
            let filteredItem = this.items.filter(x=>x.content.id==id);
            if(filteredItem.length>0){
                this.selectedItem = filteredItem[0].content;
            }else{
                try {
                    this.isLoading = true;
                    let result = await this.loadById(id);
                    if(result==null){
                        this.items.clear();
                        this.selectedItem = null;
                    }else{
                        let container = new itemContainer(this);
                        container.content = result;
                        container.isSelected = true;
                        this.items.update(...[container]);
                        this.selectedItem = result;
                    }
                } catch (ex) {
                    console.log(ex);
                } finally {
                    this.isLoading = false;
                }
            }
        }
    }
    private lastRunAction:any;
    runLast(){
        if(this.useReturnKey==true){
            this.refresh();
            return;
        }
        if(this.lastRunAction!=null)
            this.lastRunAction();
    }
    protected abstract loadData(searchedText:string):Promise<T[]>; 
    protected abstract loadById(id:string):Promise<T>;

    select(container : itemContainer<T>) {
        this.selectedItem = container.content;
        this.items.forEach((element,i) => {
            if(element!=container){
                element.isSelected = false;
            }else{
                element.isSelected = true;
            }
        });
    }
    onSelectionChanged(element:T){};
}


export class itemContainer<T extends ElementType> extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:SearchableSelectorBaseViewModel<T>) {
        super(parent);
        this._typedParent = parent;
        
    }
    private _typedParent : SearchableSelectorBaseViewModel<T>;
    public set content(v: T) { this._content = v; } public get content(): T { return this._content;} private _content: T;
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;

    select(){
        this._typedParent.select(this);
    }
}
